document.querySelectorAll(".nav-main .nav-item").forEach(elem =>
    elem.addEventListener("mouseenter", sub => {
        let dropdown = elem.querySelector(".dropdown-menu"); if(!dropdown) return;
        let navmain = document.querySelector(".nav-main"); if(!navmain) return;
        if(window.getComputedStyle(navmain).getPropertyValue("flex-wrap") != "nowrap") dropdown.style.top = elem.offsetTop + 40 + "px";
        else dropdown.style.removeProperty("top");
    })
);
